import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { useResourceDataContextSafe } from '../context/resourceDataContext.js';
import { useExpandedFdocContext } from './ExpandedFdocProvider.js';
import { AnonBottomBarSignup } from '../ExpandedResource/ExtraPanel/AnonBottomBarSignup.js';
import { CloseIcon } from '@fabric-app/icons/icons';
import SimilarItemsList from './SimilarItemsList.js';
import { ExpandedFdocElements } from './ExpandedFdocElements.js';
import Truncator from '@fabric-app/ui/components/Truncator/Truncator';

const ExpandedFdocSidebar_SimilarContent = ({ hideSimilar, isFullscreen }) => {
  const [similarTextRef, setSimilarTextRef] = React__default.useState(null);
  const { resource } = useResourceDataContextSafe();
  const { similarText, setSimilarText, isAnon } = useExpandedFdocContext();
  if (hideSimilar) {
    return;
  }
  if (isAnon) {
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [
        /* @__PURE__ */ jsx(ExpandedFdocElements.ItemPreviewSidebarCommentsEmpty, {
          style: {
            paddingTop: 20,
            flexGrow: 1
          },
          children: "Nothing to show here."
        }),
        /* @__PURE__ */ jsx(AnonBottomBarSignup, {
          children: /* @__PURE__ */ jsx("p", {
            children: "Similar items are only available to logged-in users."
          })
        })
      ]
    });
  }
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [
      similarText && /* @__PURE__ */ jsxs(ExpandedFdocElements.ItemPreviewSidebarSimilarBadge, {
        ref: setSimilarTextRef,
        children: [
          /* @__PURE__ */ jsx("span", {
            children: "Similar to: “"
          }),
          /* @__PURE__ */ jsx(ExpandedFdocElements.ItemPreviewSidebarSimilarBadgeText, {
            children: /* @__PURE__ */ jsx(Truncator, {
              text: similarText,
              maxRows: 2,
              parentRef: similarTextRef,
              offsetBefore: 63
            })
          }),
          /* @__PURE__ */ jsx("span", {
            children: "”"
          }),
          /* @__PURE__ */ jsx(ExpandedFdocElements.ItemPreviewSidebarSimilarBadgeButton, {
            tabIndex: 7,
            onClick: () => setSimilarText?.(void 0),
            children: /* @__PURE__ */ jsx(CloseIcon, {})
          })
        ]
      }),
      /* @__PURE__ */ jsx(SimilarItemsList, {
        similarTo: similarText ?? resource,
        selectedFdocId: resource.id,
        isFullscreen
      })
    ]
  });
};

export { ExpandedFdocSidebar_SimilarContent };
//# sourceMappingURL=ExpandedFdocSidebar_SimilarContent.js.map
